import type { AccountStatusUser } from "@/lib/auth/accountStatus";
import { hasVerifiedAccount } from "@/lib/auth/accountStatus";

interface CreditGateResumeReadiness {
  user: AccountStatusUser | null | undefined;
  authLoading: boolean;
  creditsLoading: boolean;
}

/**
 * Keep the post-auth credit marker intact until Auth has replaced the
 * anonymous session with a permanent account and the account balance is
 * known. Consuming it earlier can race form restoration and strand the new
 * account back at the create entry screen without the promised pack chooser.
 */
export function canResumeCreditGate({
  user,
  authLoading,
  creditsLoading,
}: CreditGateResumeReadiness): boolean {
  return !authLoading && !creditsLoading && hasVerifiedAccount(user);
}
